export default function($) {
  let missionsSwiper = document.querySelector('.js-missions-slider');
  let similarPostsSwiper = document.querySelector('.js-similar-posts-slider');
  let sponsorsSwiper = document.querySelector('.js-sponsors-slider');

  const missionsSwiperParams = {
    slidesPerView: 1,
    spaceBetween: 32,
    pagination: {
      el: ".missions-swiper-pagination",
      clickable: true,
    },
    loop: false,
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 32,
        loop: false,
      },

      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
        loop: false,
      },
    },
    on: {
      destroy: function() {
        $('.missions-swiper-pagination').hide();
      },
      init: function() {
        $('.missions-swiper-pagination').show();

      },
    },
  };

  const postsSwiper = new Swiper('.js-posts-slider', {
    slidesPerView: 1.2,
    spaceBetween: 16,
    pagination: {
      el: ".posts-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      }
    },
  });

  const similarPostsSwiperParams = {
    slidesPerView: 1.2,
    spaceBetween: 16,
    pagination: {
      el: ".similar-posts-swiper-pagination",
      clickable: true,
    },
    breakpoints: {
      640: {
        slidesPerView: 2,
        spaceBetween: 32,
      },
      1024: {
        slidesPerView: 3,
        spaceBetween: 32,
      }
    },
    on: {
      destroy: function() {
        $('.similar-posts-swiper-pagination').hide();
      },
      init: function() {
        $('.similar-posts-swiper-pagination').show();

      },
    },
  };

  const sponsorsSwiperParams = {
    slidesPerView: 3,
    spaceBetween: 32,
    pagination: {
      el: ".sponsors-swiper-pagination",
      clickable: true,
    },
    loop: false,
    autoplay: {
      delay: 2500,
      pauseOnMouseEnter: true,
    },
    breakpoints: {
      480: {
        slidesPerView: 4,
        spaceBetween: 32,
        loop: false,
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 32,
        loop: false,
      },
    },
    on: {
      destroy: function() {
        $('.sponsors-swiper-pagination').hide();
      },
      init: function() {
        $('.sponsors-swiper-pagination').show();

      },
    },
  };

  swiperDisplay();

  $(window).resize(function() {
    swiperDisplay();
  })

  function swiperDisplay() {
    if( $(window).width() < 1024 ) {
      if( $('.js-missions-slider').length > 0 && !missionsSwiper.initialized ) {
        missionsSwiper = new Swiper('.js-missions-slider', missionsSwiperParams);
      };
      if( $('.js-sponsors-slider').length > 0 && !sponsorsSwiper.initialized ) {
        sponsorsSwiper = new Swiper('.js-sponsors-slider', sponsorsSwiperParams);
      };
    }
    else {
      if( $('.js-missions-slider').length > 0 && missionsSwiper.initialized ) {
        missionsSwiper.destroy(false,true);
        $('.js-missions-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('.missions-swiper-pagination').hide();
      };
      if( $('.js-sponsors-slider').length > 0 && sponsorsSwiper.initialized ) {
        sponsorsSwiper.destroy(false,true);
        $('.js-sponsors-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('.sponsors-swiper-pagination').hide();
      };
    }
    if( $(window).width() < 1280 ) {
      if( $('.js-similar-posts-slider').length > 0 && !similarPostsSwiper.initialized ) {
        similarPostsSwiper = new Swiper('.js-similar-posts-slider', similarPostsSwiperParams);
      };
    }
    else {
      if( $('.js-similar-posts-slider').length > 0 && similarPostsSwiper.initialized ) {
        similarPostsSwiper.destroy(false,true);
        $('.js-similar-posts-slider').find('.swiper-wrapper').removeAttr('style');
        return;
      } else {
        $('.similar-posts-swiper-pagination').hide();
      };
    }
  }

  const bannerSwiper = new Swiper('.js-banner-slider', {
    slidesPerView: 1,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
  });
};
